import { BorderRadius } from '../../../enums/borderRadius'
import { Size } from '../types/size'

interface ControlProperties {
  dimension: number
  iconScale: number
  radius: BorderRadius
}

export const sizeToProperties: Record<Size, ControlProperties> = {
  m: { dimension: 16, iconScale: 1, radius: BorderRadius.R2 },
  l: { dimension: 20, iconScale: 1.2, radius: BorderRadius.R2 },
}
